"use client";

import { IconProps } from "../common/icons";
import { SignInFormVariant } from "./SignInSignUpForm";
import { cn } from "@punchup/utils/cn";

interface Props {
  label: string;
  Icon: React.FC<IconProps>;
  name: string;
  value: string;
  variant?: SignInFormVariant;
  className?: string;
}

export default function SignInButton({
  label,
  Icon,
  name,
  value,
  variant = "normal",
  className,
}: Props) {
  return (
    <button
      type="submit"
      name={name}
      value={value}
      className={cn(
        "flex flex-row justify-center items-center p-4 border border-[#EAEAEA] rounded-md bg-white hover:bg-gray-50 transition-colors duration-200 ease-in-out",
        variant === "minimal" && "p-3",
        className
      )}
      aria-label={label}
    >
      <Icon
        width={variant === "minimal" ? 20 : 24}
        height={variant === "minimal" ? 20 : 24}
        className="inline-block"
      />
      <span className="sr-only">{label}</span>
    </button>
  );
}
